import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import {useEffect} from 'react'

import useCanonical from '~/hooks/useCanonical'
import VerifyEmailMutation from '~/mutations/VerifyEmailMutation'
import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import Ellipsis from './Ellipsis/Ellipsis'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'
import PrimaryButton from './PrimaryButton'
import TeamInvitationWrapper from './TeamInvitationWrapper'




const VerifyEmail = (props) => {
  const {history, match} = props
  const {params} = match
  const {verificationToken, invitationToken} = params
  const atmosphere = useAtmosphere()
  const {onCompleted, onError, error, submitMutation} = useMutationProps()
  useCanonical('verify-email')
  useEffect(() => {
    submitMutation()
    VerifyEmailMutation(
      atmosphere,
      {verificationToken, invitationToken: invitationToken || '', isInvitation: !!invitationToken},
      {onCompleted, onError, history}
    )
  }, [])
  return (
    _jsx(TeamInvitationWrapper, { children: 
      _jsxs(InviteDialog, { children: [
        _jsx(DialogTitle, { children: "Email Verification" })
        , _jsxs(DialogContent, { children: [
          _jsx(InvitationDialogCopy, { children: error ? error.message : 'You’re almost in!'})
          , _jsx(InvitationCenteredCopy, { children: 
            !error && (
              _jsxs(PrimaryButton, { size: "medium", waiting: true, children: [
                _jsx('span', { children: "Verifying now" })
                , _jsx(Ellipsis, {} )
              ]})
            )
          })
        ]})
      ]})
    })
  )
}

export default VerifyEmail
